import styled, { css } from 'styled-components/macro'

import { settings } from '../../../styled/settings/index';
import { mixins } from '../../../styled/mixins/index';

const {
  colors: { color, hexToRGBa },
  mediaqueries: { mobileDown, tabletLandscapeDown, tabletPortraitDown, tabletPortraitUp },
  sizing: { spacingsize, radiussize },
  shadows: { buttonShadowDefault },
} = settings;

const {
  layout: { centered, centeredContent, pageSection, pageSectionInner },
  typography: { buttonText, heading1, heading2, heading3, heading5, heroDescription, linkButtonText },
} = mixins;

export const TwoColumnRow = styled.div`
  margin: ${spacingsize(5)} 0;
  display: grid;
  grid-template-columns: 35% 5% 60%;

  @media ${tabletLandscapeDown} {
    grid-template-columns: 47.5% 5% 47.5%;
  }

  @media ${mobileDown} {
    
  }
`;

export const FirstColumn = styled.div`
  grid-column-start: 1;
  grid-column-end: 2;
`;

export const SecondColumn = styled.div`
  grid-column-start: 3;
  grid-column-end: 4;

  .EnquiryForm {
    max-width: 100%;
  }
`;

export const AppForm = styled.form`
  
`;

export const FormStepTitle = styled.h2`
  ${heading2}
  text-transform: uppercase;
  color: ${color(`teal`)};
  text-align: center;
  font-weight: 500;
  padding-top: ${spacingsize(10)};

  &.current-step-2 {
    margin-bottom: ${spacingsize(10)};
  }
`;

export const FormSectionTitle = styled.h3`
  ${heading3}
  margin: ${spacingsize(10)} 0;
`;

const stepContainerStyles = css`
  display: none;
  width: 100%;
  padding-bottom: 5rem;
  border-bottom: solid 3px ${color(`black`)};

  &.show {
    display: block;
  }
`;

export const Step1Container = styled.span`
  ${stepContainerStyles}
`;

export const Step2Container = styled.span`
  ${stepContainerStyles}
`;

export const BookATourFormLabel = styled.label`
  ${heroDescription}
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  position: relative;

  &.has-arrow:after {
    content: '';
    position: absolute;
    right: 3px;
    top: 50%;
    border-right: 1px solid;
    border-bottom: 1px solid;
    height: 10px;
    width: 10px;
    transform: translateY(-75%) rotate(45deg);
    pointer-events: none;
  }
`;

export const BookATourFormLine = styled.svg`
  width: 100%;
  height: 1px;
  stroke: #bababa;
  stroke-width: 2px;

  .focus {
    stroke: black;
  }

  .valid {
    stroke: hsl(166, 72%, 40%);
  }

  .invalid {
    stroke: #ff3d3d;;
  }

  .focus,
  .valid,
  .invalid {
    transition: all 0.2s;
    stroke-dasharray: 0, 20;
    stroke-dashoffset: -20;
  }
`;

const inputStyles = css`
  font-family: inherit;
  font-weight: 400;
  flex-grow: 1;
  box-sizing: border-box;
  display: block;
  margin: 0;
  border: none;
  border-bottom: 1px solid #bababa;
  padding: 0.75rem 0.5rem;
  line-height: 1;
  transition: border-color 0.2s;
  resize: none;

  &:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 1000px white inset !important;
  }

  &:focus {
    outline: none;
    border-color: black;
  }

  &[disabled] {
    opacity: 0.4;
    pointer-events: none;
    cursor: progress;
  }

  &::placeholder {
    text-transform: none;
  }

  &:focus ~ ${BookATourFormLine} .focus,
  &:valid ~ ${BookATourFormLine} .valid,
  &[data-touched]:invalid ~ ${BookATourFormLine} .invalid {
    stroke-dasharray: 40, 0;
    stroke-dashoffset: 0;
  }

  &.textfield {
    width: 100%;
  }

  &.datemonth, &.dateday {
    width: 4rem;
    display: inline-block;
  }

  &.dateyear {
    width: 6rem;
    display: inline-block;
  }

  &.error {
    border-color: ${color(`red`)};
  }
`;

export const BookATourFormInput = styled.input`
  ${inputStyles}
`;

export const SelectInputContainer = styled.div`
  min-width: 200px;

  display: flex;
  align-items: center;
  flex-wrap: wrap;
  position: relative;

  &:after {
    content: '';
    position: absolute;
    right: 3px;
    top: 50%;
    border-right: 1px solid;
    border-bottom: 1px solid;
    height: 10px;
    width: 10px;
    transform: translateY(-75%) rotate(45deg);
    pointer-events: none;
  }

  &.error{
    &:after{
      border-color: ${color(`red`)};
      color: ${color(`red`)};
    }
  }
`;

export const SelectInput = styled.select`
  ${inputStyles}
  border-radius: 0;
  background: none;
  appearance: none;

  &.error {
    border-color: ${color(`red`)};
  }
`;

export const BookATourFormSubmitButton = styled.button`
  &[disabled] {
    opacity: 0.4;
    pointer-events: none;
    cursor: progress;
  }
`;

export const FormLabel = styled.label`
  ${heading3}
`;

export const RequiredAsterisk = styled.span`
  color: ${color(`red`)};
`;

export const CheckboxLabel = styled.label``;
export const CheckboxInput = styled.input``;

export const CheckboxContainer = styled.div`
  line-height: 24px;
  font-size: 16px;
  box-sizing: border-box;

  ${CheckboxInput} {
    opacity: 0;
  }

  ${CheckboxLabel} {
    position: relative;
    display: inline-block;
    /*16px width of fake checkbox + 6px distance between fake checkbox and text*/
    padding-left: 22px;
  }

  ${CheckboxLabel}::before{
    position: absolute;
    content: "";
    
    /*Needed for the line-height to take effect*/
    display: inline-block;
  }

  ${CheckboxLabel}::after {
    position: absolute;
    content: "";
    
    /*Needed for the line-height to take effect*/
    display: inline-block;
  }

  ${CheckboxLabel}::before {
    height: 16px;
    width: 16px;
    
    border: 1px solid;
    left: 0px;
    
    /*(24px line-height - 16px height of fake checkbox) / 2 - 1px for the border
     *to vertically center it.
     */
    top: 3px;
  }

  ${CheckboxLabel}::after {
    height: 5px;
    width: 9px;
    border-left: 2px solid;
    border-bottom: 2px solid;
    
    transform: rotate(-45deg);
    
    left: 4px;
    top: 7px;
  }

  ${CheckboxInput} + ${CheckboxLabel}::after{
    content: none;
  }

  ${CheckboxInput}:checked + ${CheckboxLabel}::after{
    content: "";
  }

  ${CheckboxInput}:focus + ${CheckboxLabel}::before {
    outline: rgb(59, 153, 252) auto 5px;
  }
`;

export const StepNavigationContainer = styled.div`
  margin: ${spacingsize(10)} 0;
  display: grid;
  grid-template-columns: 25% 50% 25%;

  @media ${tabletLandscapeDown} {
    grid-template-columns: 35% 30% 35%;
  }

  @media ${mobileDown} {
    
  }
`;

export const StepNavigationBackButton = styled.button`
  grid-column-start: 1;
  grid-column-end: 2;
  background: ${color(`teal`)} !important;

  &:hover {
    background: ${color(`white`)} !important;
    border: solid 1px ${color(`teal`)};
    color: ${color(`teal`)};
  }

  &:focus {
    background: ${color(`teal`)} !important;
  }

  &[disabled] {
    opacity: 0.4;
    pointer-events: none;
    cursor: progress;
  }

  &.hide {
    display: none;
  }
`;

export const StepNavigationNextButton = styled.button`
  grid-column-start: 3;
  grid-column-end: 4;

  &:hover {
    background: ${color(`white`)} !important;
    border: solid 1px ${color(`black`)};
    color: ${color(`black`)};
  }

  &:focus {
    background: ${color(`black`)} !important;
  }

  &[disabled] {
    opacity: 0.4;
    pointer-events: none;
    cursor: progress;
  }

  &.hide {
    display: none;
  }
`;

export const ErrorContainer = styled.div`
  width: 100%;
  padding: ${spacingsize(10)};
  border: solid 2px ${color(`red`)};

  h5 {
    color: ${color(`red`)};
  }
`;

export const Step3Container = styled.div`
  h3 {
    ${heading3}
  }

  p, ul li {
    ${heroDescription}
  }

  &.hide {
    display: none;
  }
`;

export const TutitionScheduleGrid = styled.div`
  display: grid;
  grid-template-columns: 40% 20% 40%;
  text-align: center;

  @media ${tabletLandscapeDown} {
    grid-template-columns: 45% 10% 45%;
  }

  @media ${mobileDown} {
    
  }
`;

export const TutitionColumnOne = styled.div`
  grid-column-start: 1;
  grid-column-end: 2;
`;

export const TutitionColumnTwo = styled.div`
  grid-column-start: 3;
  grid-column-end: 4;
`;

export const SubmitButton = styled.button`
  background: ${color(`red`)} !important;
  grid-column-start: 3;
  grid-column-end: 4;

  &:hover {
    background: ${color(`red`)} !important;
    border: solid 1px ${color(`black`)};
    color: ${color(`black`)};
  }

  &:focus {
    background: ${color(`black`)} !important;
  }

  &[disabled] {
    opacity: 0.4;
    pointer-events: none;
    cursor: progress;
  }

  &.hide {
    display: none;
  }
`;